var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"successPage"},[_c('div',{staticClass:"page-box"},[_c('img',{attrs:{"src":require("../assets/success-icon.png"),"alt":""}}),_c('p',[_vm._v("支付成功")])])])
}]

export { render, staticRenderFns }